export default __webpack_public_path__ + "static/media/hipaa.6c3d8fb4.png";